import React, { memo } from 'react';
export const ForWhoSection = memo(function ForWhoSection() {
  const avatars = [{
    icon: '🔌',
    title: 'Querés aprender electricidad desde cero',
    desc: 'No sabés nada del tema y necesitás un método claro, seguro y progresivo para arrancar sin riesgos desde el primer día.'
  }, {
    icon: '🏠',
    title: 'Querés independencia en tu hogar',
    desc: 'Estás harto de pagar fortunas por arreglos simples. Querés resolver los problemas de tu casa vos mismo y ahorrar todos los meses.'
  }, {
    icon: '💼',
    title: 'Necesitás una salida laboral urgente',
    desc: 'Buscás un oficio demandado que te permita generar ingresos reales en el corto plazo. La electricidad es el trabajo que nunca falta en Argentina.'
  }];
  return <section className="py-16 px-4 bg-gray-900 border-t border-gray-800" data-id="element-84">
      <div className="max-w-4xl mx-auto" data-id="element-85">
        {/* Header */}
        <div className="text-center mb-10" data-id="element-86">
          <h2 className="text-[24px] md:text-4xl font-black text-white leading-tight" data-id="element-87">
            Este Megapack{' '}
            <span className="text-blue-500" data-id="element-88">es para vos si...</span>
          </h2>
        </div>

        {/* Avatars Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5" data-id="element-89">
          {avatars.map((avatar, index) => <div key={index} className="bg-gray-800 border border-gray-700 rounded-2xl p-6 hover:border-blue-500/50 transition-colors flex flex-col items-center text-center shadow-lg" data-id="element-90">
              <div className="text-4xl mb-4 bg-gray-900 p-3 rounded-full border border-gray-700" data-id="element-91">
                {avatar.icon}
              </div>
              <h3 className="text-[17px] font-black text-white mb-3 leading-snug" data-id="element-92">
                {avatar.title}
              </h3>
              <p className="text-gray-400 text-[13px] leading-relaxed" data-id="element-93">
                {avatar.desc}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
});